import React, { useContext, useEffect, useState } from 'react';
import { StyleContext } from '../../providers/StyleContextProvider';
import { useMediaQuery } from 'react-responsive';
import { ReactComponent as CloseIcon} from "../../assets/svg/close-circle-red.svg";

const STORAGE_KEY = 'scam_alert_banner_closed';

export const ScamAlertBanner: React.FC = () => {
    const styleContext = useContext(StyleContext);
    const isMobile = useMediaQuery({ query: '(max-width: 786px)' });
    const [styles, setStyles] = useState<any>(styleContext.getComponentStyle('scamAlertBanner'));
    const [isShow, setIsShow] = useState<boolean>(false);
  
    useEffect(() => {
      setStyles(styleContext.getComponentStyle('scamAlertBanner'));
    }, [isMobile, styleContext]);
  
    useEffect(() => {
      const isClosed = sessionStorage.getItem(STORAGE_KEY);
      setIsShow(!isClosed);
    }, []);
  
    const handleClose = (): void => {
      sessionStorage.setItem(STORAGE_KEY, 'true');
      setIsShow(false);
    };
  
    if (!isShow) return null;
  
    return (
      <div style={styles}>
        <CloseIcon style={styles.closeIcon} onClick={handleClose} />
        <div style={styles.header}>
          <span style={styles.boldText}>{"Notice of Scam Alert:"}</span>
          <span>{" We have received reports of scammers falsely using the XpressJobs name on platforms such as "}</span>
          <span style={styles.boldTextAndUnderline}>{"Telegram, WhatsApp, and Instagram."}</span>
        </div>
        <div style={styles.bodyMessage}>
          <span>{"Please be advised that"}</span>
          <span style={styles.boldText}>{" XpressJobs does not request personal information or payments via messaging apps."}</span>
        </div>
      </div>
    );
  };